export default __webpack_public_path__ + "media/pandemicMockup.4bb98e33.mp4";